import React, { FC, useContext } from 'react';
import { DataContext } from '../../context/dataLoader/DataLoader';

import './DevPage.scss';



const DevPage: FC = () => {

    const data = useContext(DataContext);

    if (data.simModel) {

    }

    return <div className='Page'>
        <div>You shouldn't have access to this page...</div>
    </div>
}

export default DevPage;